<template>
  <v-tabs class="sub-menu md-3" slider-color="primary">
    <v-tab class="sub-menu-item" to="/settings/organizational-structure" exact>
      {{ $t("settings.organisationStructure.menu.mainSettings") }}
    </v-tab>
    <v-tab class="sub-menu-item" to="/settings/organizational-structure/users">
      {{ $t("settings.organisationStructure.menu.userSettings") }}
    </v-tab>
  </v-tabs>
</template>

<script>
export default {
  name: "OrganizationalStructureMenu"
};
</script>

<style scoped></style>
